.background {
    background-image: url('/sm_mountainBkgrd.jpg');
    background-size: cover;
    background-repeat: no-repeat;
}

.pageHeaderContent {
    margin: auto;
    max-width: 1300px;
    padding: 20px;
}

.contentWrapper {
    display: flex;
    max-width: 1300px;
    margin: 0 auto;
    padding-bottom: 150px;
    width: 100%;
}

.mainColumn {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    padding: 0px 24px;
    margin-top: 24px;
}

.titleAndButtons {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.dashlets {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.pageBody {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.pageBodySection {
    background-color: var(--hps-white);
    border-radius: 1rem;
    padding: 20px;
    width: 100%;
}

.titleAndButtons {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.buttons {
    display: flex;
    gap: 25px;
}

.sidebar {
    width: 260px;
    background: linear-gradient(180deg, #0a3140 0%, #153d52 100%);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
}

.container {
    display: flex;
    flex-direction: column;
}

.sidebarHeader {
    padding: 16px 16px 16px 32px;
}

.groupList {
    flex: 1;
    overflow-y: auto;
}

.groupItem {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 32px;
    margin-bottom: 8px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-align: left;
}

.groupItem:hover {
    background-color: rgba(255, 255, 255, 0.04);
}

.groupItem.selected {
    background-color: rgba(255, 255, 255, 0.04);
    border-left: 5px solid;
    border-image: linear-gradient(to bottom, #05a4ee, #006ea2) 1 100%;
    padding-left: 27px;
}

.groupItemContent {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.groupNameRow {
    display: flex;
    align-items: center;
    gap: 6px;
}

.textInactive {
    color: #758c98;
}

.textActive {
    color: var(--hps-white);
}
